var map = {
	"./symbol_0.png": "02b8",
	"./symbol_1.png": "b5d7",
	"./symbol_10.png": "58ab",
	"./symbol_2.png": "8acc",
	"./symbol_3.png": "3d3f",
	"./symbol_4.png": "86b5",
	"./symbol_5.png": "0920",
	"./symbol_6.png": "7737",
	"./symbol_7.png": "7c49",
	"./symbol_8.png": "7688",
	"./symbol_9.png": "e6c6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90d5";